import { Tables } from '@/lib/supabase/supabase_types';
import { X, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { crmSystem } from "@/constants/crm/_shared/systems";
import { QuestionFormSchemaType } from "@/features/question/components/organisms/QuestionForm/QuestionForm.types";
import { UseFormReturn } from "react-hook-form";
import { useFieldArray } from "react-hook-form";
import { ConditionFields } from "./ConditionFields";

type Props = {
    index: number;
    form: UseFormReturn<QuestionFormSchemaType>;
    removeConditionGroup: (index: number) => void;
    questions: Tables<'question'>[];
    crmSystem?: crmSystem;
    length: number;
}

export const ConditionGroup = ({
    index,
    form,
    removeConditionGroup,
    questions,
    crmSystem,
    length,
}: Props) => {
    const { fields, append, remove } = useFieldArray({
        control: form.control,
        name: `selected_configuration.conditionals.where.or.${index}.and`,
    });

    return (
        <>
            <div className="p-2 border rounded-md">
                <div className="flex justify-end">
                    <Button size="action" variant="ghost" type="button" onClick={() => removeConditionGroup(index)}>
                        <X size="16" />
                    </Button>
                </div>
            
                <div className="flex flex-col gap-2">
                    { fields.map((field, conditionIndex) => (
                        <ConditionFields 
                            key={field.id}
                            groupIndex={index}
                            conditionIndex={conditionIndex}
                            form={form}
                            remove={remove}
                            questions={questions}
                            crmSystem={crmSystem}
                        />
                    ))}

                </div>

                <div>
                    <Button size="sm"  variant="outline" type="button" className="mt-2" onClick={() => append({})}>
                        <Plus size="16" /> {fields.length > 0 ? 'AND' : 'Add Condition'}
                    </Button>
                </div>
            </div>

            { (length > 1) && (index < length - 1) && (
                <div className="flex items-center justify-center my-2">
                    <span className="text-sm text-gray-500">or</span>
                </div>
            )}
        </>
    )
}
